import React from 'react';
import Chat from '../../messages/chat';

export default () => <Chat path={window.location.pathname}/>;
